/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const CHECK = 'CHECK';
export const REGISTER = 'REGISTER';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const USER = 'USER';
export const POST_SUBSCRIPTION = 'POST_SUBSCRIPTION';

export const EMAIL_SUBSCRIPTION = 'EMAIL_SUBSCRIPTION';
export const POINTS = 'POINTS';

export default {
  CHECK,
  REGISTER,
  LOGIN,
  LOGOUT,
  USER,
  POST_SUBSCRIPTION,
  POINTS,
  EMAIL_SUBSCRIPTION,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js